﻿import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/catch';
// APP 
import { SiteEntity } from '../../viewmodel';
import { EntityParam } from '../../viewmodel';
import { SiteEntityParam } from '../../viewmodel';
import { LookupService } from '../../services/lookup.service';
import { EntityService } from '../../services/entity.service';
import { SharedService } from '../../services/shared.service';
import { HelperService } from '../../services/helper.service';
import { FoucsChangeService } from '../../services/focuschange.service';

@Component({
    selector: 'app-createentity',
    templateUrl: './addsiteentity.component.html',
    providers: [EntityService]
})
export class AddSiteEntityComponent implements OnInit {
    title: string = 'Add Site Entity';
    Instruction: string = 'A site entity is any entity that is a part of the MIH Site construction project. Please identify the entities that are a part of this site team. <span class="bold">Your site team must include at least one Applicant, Owner, and Architect at initial submission.</span>';

    entityForm: FormGroup;
    public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    public tinMask = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    public zipMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    
    pageError: any = [];
    pageSuccess: any = [];
    showVerifyAlert: boolean = false;
    clickType: string = "";
    showClearButton: boolean = false;
    showAddressForm: boolean = false;
    showAddressDDL: boolean = false;
    attrDisabled: any = null;   //'disabled'  or null for enable
    isFound: any = null; //'disabled'  or null for enable
    buttonDisable: boolean = false;
    applicant: boolean = false;
    submitted: boolean = false;
    searchClicked: boolean = false;
    entityRoles: any;
    states: any;
    taxIDTypes: any;
    userAssociationTypes: any;
    entityRole: number = 0;
    PartyRoleName: string;
    sitebid: number; 
    error: string;
    projectId: number = 0;
    entityId: number = 0;
    isVerified: boolean;
    verifyClicked: boolean;
    siteAddress: string;
    addresses: any = [];

    type: string;
    entity: any;

    initOrganization: string = ''; 
    initTin: string = ''; 
    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private lookupService: LookupService
        , private entityService: EntityService
        , private sharedService: SharedService
        , private helperService: HelperService
        , private foucsChangeService: FoucsChangeService) {
        this.entity = new SiteEntity();
        this.entity.entityId = 0;
        this.clearInput();
    }

    ngOnInit() {
        
	let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.entity.projectId = this.projectId = ids.projectId;
            }
 	    }
        if (this.projectId <= 0)
            this.sharedService.navigateHome();

        if (this.sharedService.getData('SiteEntityParam') != null) {    
            let param = JSON.parse(this.sharedService.getData('SiteEntityParam'));                       
            this.entity.ProjectBuildingID = param.sep.siteProjectBuildingId;             
            this.entity.ProjectBldgDevTeamID = param.sep.ProjectBldgDevTeamID; 
            this.entity.BuildingID = param.sep.bldgId; 
            this.siteAddress = param.sep.siteAddress;  
            if (param.sep.entityRole != null) {
                this.entity.entityRole = this.entityRole = param.sep.entityRole ;
            }           
        }
        else {
            this.sharedService.navigateSummary();
        }
        
        if (this.projectId <= 0 || this.entity.ProjectBuildingID <=0 ) {
            this.sharedService.navigateHome();
        }

        this.entityForm = this.frmBuilder.group({
            entityRole: [{ value: this.entityRole, disabled: (this.applicant === true || this.entity.entityId > 0) }, [Validators.required]],
            isOwner: [null],
            organization: ['', [Validators.required]],
            tin: [null, [Validators.required, Validators.pattern(/^(\d{9}|\d{2}-\d{7})$/)]],
            address1: [null, [Validators.required]],
            address2: [],
            city: [null, [Validators.required]],
            state: [33, [Validators.required]],
            zipCode: [null, [Validators.required, Validators.pattern(/^([0-9]{9}|[0-9]{5}(?:-[_]{4})?|[0-9]{5}(?:-[0-9]{4})?)$/)]],
            phone: [null, [Validators.required, Validators.pattern(/^\([1-9]\d{2}\)\s\d{3}-\d{4}|[1-9]\d{9}$/)]],
            fax: [null, [Validators.pattern(/^\([1-9]\d{2}\)\s\d{3}-\d{4}|[1-9]\d{9}$/)]],

        });

        this.lookupService.getLookups('ProjectRoleType')
            .subscribe(
            successResp => {
                if (!successResp.Success)
                    this.showError(successResp.StatusMessage);
                else
                    this.userAssociationTypes = successResp.Result
            },
            error => {
                this.showError(error.ExceptionMessage)
            });  

        this.lookupService.getLookups('State')
            .subscribe(
            successResp => {
                if (!successResp.Success)
                    this.showError(successResp.StatusMessage);
                else {
                    //this.states = successResp.Result; 
                    var stateArray = successResp.Result;
                    if (stateArray != null && stateArray.length > 0) {
                        stateArray = stateArray.slice(0, stateArray.length - 1); //remove outofUSA
                        this.states = stateArray;
                    }
                }
            },
            error => {
                this.showError(error.ExceptionMessage)
            });

        // Check for update  
        if (this.entity.entityId != null && this.entity.entityId > 0) {
          
            this.entityService.getSiteEntitiyBySiteEntityId(this.entity.entityId)
                .subscribe(
                successResp => {
                    if (!successResp.Success)
                        this.showError(successResp.StatusMessage);
                    else if (successResp.Result != null) {
                        this.entity = successResp.Result as SiteEntity; 
                    }
                },
                error => {
                    this.showError(error.ExceptionMessage)
                });
        }

        this.helperService.scrollUp(); 
    }

    //search addresses
    GetAddresses() {
        this.searchClicked = true;
        // Remove masking
        if (this.entity.tin) {
            this.entity.tin = this.entity.tin.replace(/\D/g, '');
        }  

        if (this.entity.organization == '' || this.entity.tin.length != 9) {
            return false;
        }

        this.initOrganization = this.entity.organization;
        this.initTin = this.entity.tin;        
        this.verifyClicked = true;
        this.pageError = [];   //clear error 
        this.showClearButton = true;
        this.showAddressDDL = true;
        this.showAddressForm = true;
        this.addresses = [];  //clear address array
        if (this.projectId > 0) {
        
            this.entityService.searchAddress(this.entity)
                .subscribe(
                successResp => {
                    if (!successResp.Success)
                        this.showError(successResp.StatusMessage);
                    else {
                        if (successResp.Result == null) {
                            this.isFound = null;
                            this.attrDisabled = null;                          
 			                this.buttonDisable = true;  
                        }
                        else {
                            this.isFound = 'disabled';
                            this.buttonDisable = true;
                            var partyobj = successResp.Result;
                            this.addresses = partyobj[0].PartyAddresses;                          
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');
                    this.isFound = null;
                    this.attrDisabled = null;
                    this.buttonDisable = false;
                    this.showError(error.ExceptionMessage)
                });
        }
    }

    selectAddr(index) {
        if (index >= 0) {
            this.attrDisabled = 'disabled';
            this.entity.dbApplicationId = this.addresses[index].DBApplicationID;
            this.entity.partyAddressId = this.addresses[index].PartyAddressID;
            this.entity.address1 = this.addresses[index].AddressLine1;
            this.entity.address2 = this.addresses[index].AddressLine2;
            this.entity.city = this.addresses[index].City;
            this.entity.zipCode = this.addresses[index].PostalCode;
            this.entity.phone = this.addresses[index].CorporatePhoneNumber;
            this.entity.fax = this.addresses[index].CorporateFax;
            this.entity.state = this.addresses[index].StateLookup.SeqNo;
            this.zipMaskChange();
        }
        else {
            this.attrDisabled = null;
            this.resetAddrForm();
        }
    }

    clearInput() {
        this.searchClicked = false;
        this.submitted = false;
        this.attrDisabled = null;
        this.isFound = null;
        this.buttonDisable = false;
        this.showAddressForm = false;
        this.showAddressDDL = false;
        this.clickType = "";
        this.entity.entityRole = 0;
        this.entity.organization = '';
        this.entity.tin = '';
		if (this.entityForm != null)
            this.entityForm.controls['tin'].setValue('');
        this.entity.address1 = '';
        this.entity.address2 = '';
        this.entity.city = '';
        this.entity.state = 33;  //default
        this.entity.zipCode = '';
        this.entity.phone = '';
        this.entity.fax = '';
        this.entity.isOwner = false;
        this.entity.dbApplicationId = 84;
        this.entity.partyAddressId = 0;
    }

    resetAddrForm() {
        this.clickType = "";
        this.entity.address1 = '';
        this.entity.address2 = '';
        this.entity.city = '';
        this.entity.state = 33;  //default
        this.entity.zipCode = '';
        this.entity.phone = '';
        this.entity.fax = '';
        this.entity.isOwner = false;
        this.entity.dbApplicationId = 84;
        this.entity.partyAddressId = 0;
    }

    //save site Entity
    validateEntity(buttonType): any {

        this.submitted = true;
        let entity = this.entityForm.getRawValue();
        if (!this.entityForm.valid) {
            return;
        }
        if (entity.entityRole == 0)
            return;

        // Remove masking
        if (this.entity.tin) {
            this.entity.tin = this.entity.tin.replace(/\D/g, '');
        }

        if (this.entity.zipCode) {
            this.entity.zipCode = this.entity.zipCode.replace(/\D/g, '');
        }

        if (this.entity.phone) {
            this.entity.phone = this.entity.phone.replace(/\D/g, '');
        }

        if (this.entity.fax) {
            this.entity.fax = this.entity.fax.replace(/\D/g, '');
        }

        this.entity.suppressCheck = false;
        this.save(buttonType);
    }

    confirmSave() {
        this.showVerifyAlert = false;
        this.foucsChangeService.changeFocus(true);
        this.entity.suppressCheck = true;
        this.save(this.clickType);
    }

    cancelSaving() {
        this.showVerifyAlert = false;
        this.foucsChangeService.changeFocus(true);
        this.clickType = "";
        return;
    }

    //save site entity 
    save(buttonType): any {    
      
        this.entityService.saveSiteEntity(this.entity)
            .subscribe(
            success => {
                if (!success.Success) {
                    if (success.StatusMessage == "Show Confirmation Message.") {
                        this.showVerifyAlert = true;
                        this.foucsChangeService.changeFocus(false);
                        this.clickType = buttonType;
                    }
                    else if (success.StatusMessage != null && success.StatusMessage.indexOf('entity has already been added') !== -1) {
                        this.showErrorAlert(success.StatusMessage);
                    }
                    else {
                        this.showError(success.StatusMessage);
                    }
                }
                else {
                    this.showSuccess('Development company successfully added.');
                    if (buttonType == 'NEXT') {

                        var result = success.Result;               
                        if (success.Result != null) {
                            
                            this.setSiteEntityParam(success.Result);
			                this.router.navigate(['/entity/addsitecontacts'], { replaceUrl: true });
			    
                        } 
                    }
                }
            },
            error => {
                this.showError(error.ExceptionMessage)
            })
    }

    setSiteEntityParam(sEntity) {

        var sep = new SiteEntityParam();
        sep.projectBldgDevTeamId = sEntity.MIHProjectBldgDevTeamID;   
        sep.siteProjectBuildingId = this.entity.ProjectBuildingID;
        sep.projectId = this.projectId;  
        sep.bldgId = this.entity.BuildingID; 
        sep.companyName = this.entity.organization;
        sep.tin = this.entity.tin; 
        sep.partyRoleSeqNo = this.entity.entityRole;
        sep.partyRoleName = this.PartyRoleName = this.helperService.getSiteRoleName(this.entity.entityRole);      
        sep.siteAddress = this.siteAddress;               
        sep.mood = 'A';  //Add or Edit
        sep.newEntityEntry = 'Y';         
        sep.partyId = sEntity.PartyID;
        sep.partyStagingId = sEntity.PartyStagingID;
        sep.partyAddressId = sEntity.PartyAddressID;
        sep.partyAddressStagingId = sEntity.PartyAddressStagingID;         
            
        this.sharedService.setData('SiteEntityParam', JSON.stringify({sep}));
        
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }
    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }
    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    //fix for refreshing page on enter key event
    enterKey(field, event) {
        if (event.which === 13) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }

    zipMaskChange() {
        this.zipMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

        if (this.entity.zipCode == null)
            return;

        let tempZip = this.entity.zipCode.replace(/\D/g, '');

        if (tempZip.length == 5)
            this.zipMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/]
    }

    zipCodeMaskBack() {

        this.zipMask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    }

    cancel() {
        this.sharedService.removeData('SiteEntityParam')
        this.sharedService.navigateSummary();
    }
    
    home() {
        this.sharedService.navigateHome();
    }

    back() {
        this.sharedService.navigateSummary();
    }
    
    getPhoneAndFax(address) {
        var ret = '';
        if (address.CorporatePhoneNumber != null || address.CorporatePhoneNumber == '')
            ret = " PH: " + this.helperService.formatPhone(address.CorporatePhoneNumber);

        if (address.CorporateFax != null || address.CorporateFax == '')
            ret = ret + " Fax: " + this.helperService.formatPhone(address.CorporateFax);

        return ret;
    }
    formatPhone(value) {
        if (value == null || value.length == 0)
            return "";

        let newPhone = '';
        switch (value.length) {
            case 10:
            case 9:
            case 8:
            case 7:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
                break;
            case 6:
            case 5:
            case 4:
                newPhone = value.slice(0, 3) + '-' + value.slice(3, 6);
                break;
            default:
                newPhone = value;
                break;

        }
        return newPhone;
    }
   
    checkChangeInOrganizationTin(e) {
        if (!(this.initOrganization == this.entity.organization && this.initTin == this.entity.tin)) {
            this.buttonDisable = false;
            this.resetAddrForm();
            this.showAddressDDL = false;
            this.showAddressForm = false;
        }
    }

    isEntityRoleInValid(submitted) {
        return this.entity.entityRole == 0 && this.submitted;
    }
}
